import React from 'react';
import {Dimensions} from 'react-native';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import {RFValue} from 'react-native-responsive-fontsize';
import {
  Card,
  CardDesc,
  CardTitle,
  ChevronBox,
  IconBox,
  TextArea,
  Wrapper,
} from './styles';

const SCREEN_W = Dimensions.get('window').width;
const SIDE_PAD = 24;
const CARD_W = SCREEN_W - SIDE_PAD * 2;

export type PromoCardProps = {
  title: string;
  description: string;
  icon: string;
  iconBg: string;
  iconColor?: string;
  onPress?: () => void;
};

export function PromoCard({ title, description, icon, iconBg, iconColor, onPress}: PromoCardProps) {
  return (
    <Wrapper>
      <Card cardW={CARD_W} onPress={onPress} activeOpacity={0.85}>
        <IconBox bg={iconBg}>
          <MaterialCommunityIcons
            name={icon}
            size={RFValue(18)}
            color={iconColor ?? '#fff'}
          />
        </IconBox>
        <TextArea>
            <CardTitle>{title}</CardTitle>
          <CardDesc numberOfLines={2}>{description}</CardDesc>
        </TextArea>
        <ChevronBox>
          <MaterialCommunityIcons
            name="chevron-right"
            size={RFValue(20)}
            color="#bbb"
          />
        </ChevronBox>
      </Card>
    </Wrapper>
  );
}
